<template>
  <div>
    <el-collapse v-model="activeNames" style="border-radius: 10px;">
      <el-collapse-item name="1">
        <template slot="title">
          <div style="font-size: 16px; font-weight: 600;width:100%"> <i class="el-icon-user-solid" /> 客戶資訊 </div>
        </template>
        <div style="padding: 20px;padding-bottom: 0px; font-size:14px;">
          <div v-loading="summaryLoading" style="line-height:2.6;">
            <el-row>
              <el-col :span="11" style="color:#121931; font-weight: 500;"> {{ displayInfo.fullName || '-' }} {{ genderSuffix }} </el-col>
              <el-col :span="13">
                <span style="color:#6C6B6B;margin-right:4px;">電話:</span>
                <span style="color:#121931">{{ displayInfo.phoneCode }} </span>
                <span style="color:#121931">{{ displayInfo.phoneNumber || '-' }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="11">
                <span style="color:#6C6B6B;margin-right:4px;">點數餘額:</span>
                <span style="color:#EA6A2A">{{ `${remainingPoints}點` || '-' }}</span>
              </el-col>
              <el-col :span="13">
                <span style="color:#6C6B6B;margin-right:4px;">LINE ID:</span>
                <span style="color:#121931">{{ displayInfo.lineId || '-' }}</span>
              </el-col>
            </el-row>
            <el-row style="display: flex; align-items: center;">
              <el-col :span="11" style="display: flex; align-items: center;">
                <span style="color:#6C6B6B;margin-right:4px;">會員等級:</span>
                <el-tag type="info" color="#E5E7EB" size="medium" style="color: #121931; border-radius: 8px;margin-right: 4px;">
                  {{ (displayInfo.level && displayInfo.level.title) || '-' }}
                </el-tag>
              </el-col>
              <el-col :span="13">
                <span style="color:#6C6B6B;margin-right:4px;">會員效期:</span>
                <span style="color:#121931">{{ (displayInfo.level && displayInfo.level.expiredAt) || '-' }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <span style="color:#6C6B6B;margin-right:4px;">隸屬標籤:</span>
                <el-tag v-for="tag in displayInfo.tags" :key="tag.id" type="info" color="#E5E7EB" size="medium" style="color: #121931; border-radius: 8px;margin-right: 4px;">
                  {{ tag.title }}
                </el-tag>
                <span v-if="!displayInfo.tags || displayInfo.tags.length <= 0" style="color:#121931"> - </span>
              </el-col>
            </el-row>
          </div>
          <div style="margin-top: 16px;">
            <el-row style="border-top: solid 1px #E5E7EB; padding:10px 0px">
              <el-col v-for="tab in tabs" :key="tab.value" :span="8">
                <el-button type="text" style="width: 100%;" :class="{ 'tab-button--active': activeTab === tab.value }" @click.stop="onClickTab(tab)">
                  <i :class="tab.icon" style="margin-right: 4px;color: #EA6A2A; font-size:18px;font-weight: 800;" />
                  {{ tab.name }}
                </el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>

    <!-- 右側滑出面板 -->
    <transition name="drawer-fade">
      <div v-if="useInternalDrawer && drawerVisible" class="custom-drawer-wrapper">
        <div class="drawer-overlay" @click="closeDrawer"></div>
        <div class="drawer-container">
          <div class="drawer-custom-header">
            <i class="el-icon-close close-btn" @click="closeDrawer"></i>
            <el-tabs v-model="activeTab" stretch class="drawer-tabs">
              <el-tab-pane label="會員資訊" name="information"></el-tab-pane>
              <el-tab-pane label="消費記錄" name="orders"></el-tab-pane>
              <el-tab-pane label="客戶備註" name="note"></el-tab-pane>
            </el-tabs>
          </div>
          <div class="drawer-body-scroll">
            <template v-if="activeTab === 'information'">
              <div v-if="profileLoading" v-loading="profileLoading" style="min-height: 200px;"></div>
              <MemberInfoContent v-else :info="displayInfo" @update="$emit('update', $event)" />
            </template>
            <template v-else-if="activeTab === 'orders'">
              <OrderHistoryContent :member-id="displayInfo.id" />
            </template>
            <template v-else-if="activeTab === 'note'">
              <CustomerNoteContent :member-id="displayInfo.id" />
            </template>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import MemberInfoContent from './drawer/MemberInfoContent.vue'
import OrderHistoryContent from './drawer/OrderHistoryContent.vue'
import CustomerNoteContent from './drawer/CustomerNoteContent.vue'

export default {
  name: 'CustomerInfoPartial',
  components: {
    MemberInfoContent,
    OrderHistoryContent,
    CustomerNoteContent,
  },
  props: {
    info: {
      type: [Object, null],
      default: null,
    },
    currentStep: {
      type: Number,
      default: 1,
    },
    useInternalDrawer: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      activeNames: [],
      activeTab: null,
      drawerVisible: false,
      summaryData: {},
      profileData: {},
      summaryLoading: false,
      profileLoading: false,
      profileLoaded: false,
      summaryMemberId: null,
      tabs: [
        {
          name: '會員資訊',
          value: 'information',
          icon: 'el-icon-user',
        },
        {
          name: '消費紀錄',
          value: 'orders',
          icon: 'el-icon-view',
        },
        {
          name: '客戶備註',
          value: 'note',
          icon: 'el-icon-tickets',
        },
      ],
    }
  },
  computed: {
    displayInfo() {
      const info = this.info || {}
      return {
        ...info,
        ...this.summaryData,
        ...this.profileData,
        tags: info.tags || [],
        level: {
          ...(info.level || {}),
          ...(this.summaryData.level || {}),
          ...(this.profileData.level || {}),
        },
      }
    },
    genderSuffix() {
      const gender = this.displayInfo && this.displayInfo.gender
      if (gender === 'male') return '先生'
      if (gender === 'female') return '小姐'
      return ''
    },
    remainingPoints() {
      const { point = 0, bonus = 0 } = this.displayInfo?.depositInfo?.solution2?.reduceDepositTotal || {}
      return (point ?? 0) + (bonus ?? 0)
    },
  },
  watch: {
    'info.id': {
      handler(memberId) {
        if (memberId) {
          this.resetLazyState()
          this.loadMemberSummary()
          this.expandCollapse()
        }
      },
      immediate: true,
    },
    currentStep(step) {
      if (step >= 2 && this.info?.id) {
        this.loadMemberSummary()
      }
      if (step === 3) {
        this.activeNames = []
      } else if (this.info?.id) {
        this.expandCollapse()
      }
    },
  },
  created() {
    if (this.currentStep === 3) {
      this.activeNames = []
    } else if (this.info?.id || this.currentStep >= 2) {
      this.activeNames = ['1']
    }
  },
  methods: {
    expandCollapse() {
      if (!this.activeNames.includes('1')) {
        this.activeNames = ['1']
      }
    },
    resetLazyState() {
      this.summaryData = {}
      this.profileData = {}
      this.profileLoaded = false
      this.summaryMemberId = null
    },
    async loadMemberSummary() {
      const memberId = this.info?.id
      if (!memberId || this.summaryMemberId === memberId) return
      if (this.info?.depositInfo) {
        this.summaryMemberId = memberId
        return
      }
      this.summaryLoading = true
      try {
        const summary = await this.$store.dispatch('member/fetchMemberSummary', { memberId })
        this.summaryData = summary || {}
        this.summaryMemberId = memberId
        this.$emit('merge-info', this.displayInfo)
      } catch (error) {
        console.error('取得會員摘要失敗', error)
      } finally {
        this.summaryLoading = false
      }
    },
    async loadMemberProfile() {
      const memberId = this.info?.id
      if (!memberId || this.profileLoaded) return
      this.profileLoading = true
      try {
        const profile = await this.$store.dispatch('member/fetchMemberProfile', { memberId })
        this.profileData = profile || {}
        this.profileLoaded = true
        this.$emit('merge-info', this.displayInfo)
      } catch (error) {
        console.error('取得會員詳細資料失敗', error)
      } finally {
        this.profileLoading = false
      }
    },
    async onClickTab(tab) {
      this.activeTab = tab.value
      if (this.useInternalDrawer) {
        this.drawerVisible = true
      }
      if (tab.value === 'information') {
        await this.loadMemberProfile()
      }
      this.$emit('tab-click', tab)
    },
    closeDrawer() {
      this.drawerVisible = false
      this.activeTab = null
    },
    async refreshAfterEdit() {
      this.resetLazyState()
      await this.loadMemberSummary()
      if (this.profileLoaded) {
        this.profileLoaded = false
        await this.loadMemberProfile()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-collapse {
  position: relative;
  z-index: 5;
}

::v-deep .el-collapse-item__header {
  background-color: #e5e7eb;
  border-radius: 10px;
}

::v-deep .el-collapse-item__header.is-active {
  border-radius: 10px 10px 0 0;
}

::v-deep .el-collapse-item__arrow {
  font-size: 26px;
  font-weight: 900;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0px;
}

::v-deep .el-divider--vertical {
  height: 2.2em;
  background-color: #e5e7eb;
  margin-top: 10px;
}

.tab-button--active {
  color: #121931;
  font-weight: 600;
}

/* Drawer 樣式 - 與新增寵物一致 */
.custom-drawer-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 4000;
  display: flex;
  justify-content: flex-end;
}

.drawer-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 0;
}

.drawer-container {
  position: relative;
  width: 45%;
  height: 100%;
  background: #f9f9fb;
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  z-index: 1;
}

.drawer-custom-header {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  padding-bottom: 0;
  border-bottom: 1px solid #f2f2f2;
  background: #f9f9f9;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 30;
  .close-btn {
    font-size: 32px;
    cursor: pointer;
    margin-right: 15px;
    color: #121931;
  }
  .header-title {
    color: #000000;
    font-weight: 900;
    font-size: 18px;
  }
}

.drawer-tabs {
  flex: 1;
  position: relative;
  z-index: 31;

  ::v-deep .el-tabs__header {
    margin-bottom: 0;
    position: relative;
    z-index: 31;
  }

  ::v-deep .el-tabs__nav-wrap::after {
    display: none;
  }

  ::v-deep .el-tabs__item {
    font-size: 18px;
    color: #6c6b6b;

    &.is-active {
      color: #121931;
      font-weight: 600;
    }
  }

  ::v-deep .el-tabs__active-bar {
    background-color: #ea6a2a;
    height: 3px;
  }
}

.drawer-body-scroll {
  padding: 16px 24px;
  padding-bottom: 50px;
  flex: 1;
  overflow-y: auto;
  background: #f9f9fb;
  position: relative;
  z-index: 1;
}

.drawer-fade-enter-active,
.drawer-fade-leave-active {
  transition: opacity 0.3s;
  .drawer-container {
    transition: transform 0.3s ease;
  }
}
.drawer-fade-enter,
.drawer-fade-leave-to {
  opacity: 0;
  .drawer-container {
    transform: translateX(100%);
  }
}
</style>
